import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserDataClassesData {
  dataClasses: {
    'value': string,
    'label': string,
    'container': string,
    'schemaType'?: string,
  }[]
}

export function useUserDataclasses(type?: string|null) {
  const queryClient = useQueryClient();
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userDataclasses', type],
    queryFn: async (): Promise<UserDataClassesData> => {
      const baseUrl = `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/get_user_dataclasses`;

      const url = new URL(baseUrl);
      if (type) {
        url.searchParams.append('type', type);
      }

      const response = await fetch(url.toString(), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${keycloak.token}`
        },
        method: 'GET',
      });

      let data = await response.json();

      // console.log("dataclassses1");
      // console.dir(data);

      const { dataClasses } = data?.data

      // console.log("returning:");
      // console.dir(dataClasses);

      return {
        dataClasses: dataClasses
      };
    },
  });
}
